// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"d8f233d1","816":"ebdb7260"}[chunkId] + ".chunk.css";
};